module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAPdJREFUWIXtl90OgyAMhcuy95I9GfhkxSc7u9Box8rPUEmWcG4IWNqPAikSDTUKgAXAWMUAfM/gHrq4FwDLoBGE7wGwa+v7eOzO4FZbbZQJW+vv0cCQcr40+GoCuFRnAcJZAFMyiPbTEpHbJxtjhJ08fC9hE6pIxEn2ypgmaWczdnXXUxiyMpZ1VgkAKLfjWZWeVfPWhjitxpgAYP6essuJNqgWpQz8AKr55pSfv7+GA2AADIAB0A+gqqKlZVMfSsUoRJMdAEeiMFUEnkQ/XbCw1n6WJRPHzwfjAhVgy0L+gZLTx8Kkik+yBIilY2umtCUtpLwfhqTel7MJoAt4eYoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_like@2x.png
// module id = DAME
// module chunks = 1